import React, { Component } from 'react';
import BasePage from './BasePage';
import Session from '../services/session'
import i from '../imports';
import c from '../components';

import BreadCrumbs from '../partials/BreadCrumbs';

const EMPTY_FILTER_VALUE = "empty_filter_value";


const toursToDisplay = 6;

class Excursions extends Component {

    constructor(props) {
        super(props);

        this.state = {
            cityValue: this.propsToCityFilter(props),
            tourTypeValue: this.propsToTourFilter(props),
            toursToDisplay,
            excursionsPerDestination: Session.model.destinationPages.map(
                dest => (dest) = {
                    destinationName: dest.name,
                    totalExcursions: Session.model.excursionPages.filter(f => f.destination.toLowerCase() == dest.name.toLowerCase()).length,
                    showedExcursions: 6}
                )};

    }

    handleCityChange = (event, index, value) => this.setState({
        cityValue: value,
        toursToDisplay
    });
    handleTourTypeChange = (event, index, value) => this.setState({
        tourTypeValue: value,
        toursToDisplay
    });

    readExcursions = () => {
        let filteredExcursions = Session.model.excursionPages;

        if (this.state.cityValue && this.state.cityValue != EMPTY_FILTER_VALUE) {
            filteredExcursions = filteredExcursions.filter(f => f.destination == this.state.cityValue);
        }
    }

    showMore = (destName) => {
        let destinationShowingInfo = this.state.excursionsPerDestination;
        destinationShowingInfo.filter(f => f.destinationName == destName)[0].showedExcursions += 6;
        this.setState({  excursionsPerDestination: destinationShowingInfo});
    }

    checkForMore = (destName) => {
        let destinationShowingInfo = this.state.excursionsPerDestination.filter(f => f.destinationName == destName)[0];

        return destinationShowingInfo.totalExcursions > destinationShowingInfo.showedExcursions; 
    }
    getNumber = (destName) => {
        let test = this.state.excursionsPerDestination;
        return this.state.excursionsPerDestination.filter(f => f.destinationName == destName)[0].showedExcursions;
    }

    readDestinations = (destinations) => {
        return Session.model.destinationPages.filter(dest => destinations.indexOf(dest.name.toLowerCase()) != -1);
    }

    readOtherDestinations = (destinations) => {
        return Session.model.destinationPages.filter(dest => destinations.indexOf(dest.name.toLowerCase()) == -1);
    }

    propsToTourFilter = (props) => {
        return props.type || EMPTY_FILTER_VALUE;
    }

    propsToCityFilter = (props) => {
        return props.city ? props.city : EMPTY_FILTER_VALUE;
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            cityValue: this.propsToCityFilter(nextProps),
            tourTypeValue: this.propsToTourFilter(nextProps),
        });
    }


    render() {
        
        let allExcursion = Session.model.excursionPages;

        let existsDestinations = allExcursion.map(d => d.destination.toLowerCase());

        let destinations = this.readDestinations(existsDestinations).sort((a,b) => {return a.index - b.index});

        let other_destinations = this.readOtherDestinations(existsDestinations);

        return (
            <BasePage data={Session.model.excursions}>
                <BreadCrumbs fullpath={window.location.pathname} />
                <i.Container>
                   
                    {destinations.map(dest =>
                    <div>
                        <i.Row>
                            <i.Col>
                                <h2>{dest.translations ? dest.translations[0].title : dest.title}</h2>
                                <c.CardsList 
                                items={allExcursion
                                    .filter(f => f.destination.toLowerCase() == dest.name.toLowerCase())
                                    .sort((a,b) => {return a.index - b.index})
                                    .slice(0, this.getNumber(dest.name))} 
                                urlBuilder={i.Utils.createExcursionUrl} />
                            </i.Col>
                        </i.Row>
                        <i.Row style={{ paddingBottom: 20 }}>
                            <i.Col>
                                {  this.checkForMore(dest.name) ? <h2 style={{ color: "#FF5563", cursor: "pointer" }} onClick={() => this.showMore(dest.name)}>{Session.model.common.more}</h2> : null}
                            </i.Col>
                        </i.Row>
                    </div>
                    )}

                    <i.Row style={{ paddingBottom: 20 }}>
                        <i.Col>
                            {other_destinations.length > 0 ?
                                <div>
                                    <h2>{Session.model.common.words.other_destinations}</h2>
                                    <c.CardsList items={other_destinations} urlBuilder={i.Utils.createDestinationUrl} />
                                    <h2><i.NavLink style={{ color: "#FF5563", textDecoration: "none" }} to={i.Utils.locUrl("destinations")}>{Session.model.common.words.find_more}</i.NavLink></h2>
                                </div>
                                : null
                            }
                        </i.Col>
                    </i.Row>

                </i.Container>
            </BasePage>
        );
    }
}

export default Excursions;